import { ChartConfig } from "@/components/ui/chart";

export const analyticsChartConfig = {
  page_renders: {
    label: "Page Renders",
  },
  post_renders: {
    label: "Post Renders",
  },
  unique_users: {
    label: "Daily Active Users",
  },
  post_count: {
    label: "Posts add to your feeds",
  },
} satisfies ChartConfig;
